import { render, staticRenderFns } from "./OilTracker.vue?vue&type=template&id=1ef839a4&scoped=true"
import script from "./OilTracker.vue?vue&type=script&lang=js"
export * from "./OilTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef839a4",
  null
  
)

export default component.exports